import styles from './index.module.scss'
import classNames from 'classnames';
import MainTitle from "@/components/MainTitle";
import MailingLists from './components/mailingLists'
// import Subscription from "./components/subscription";
import Chat from "./components/chat";
import OgaWebsite from './components/ogaWebsite'
// import Email from "./components/email";

const Communications = () => {
	return <div className={classNames('container', styles.communicationsBox)}>
		<MainTitle title="Communications" />
		<MailingLists />
		{/* <Subscription /> */}
		<Chat />
		<OgaWebsite />
		{/* <Email /> */}
	</div>
}
export default Communications;